import { ProfileContext } from 'application/adapters/context/Profile';
import { Profiles } from 'application/repositories/profilesRepository';
import { useState, useEffect, useContext } from 'react';
import { WelcomeHeader } from 'ui/components/2-molecules/WelcomeHeader/WelcomeHeader';

export const WelcomeHeaderFeature: React.FC<Umbraco.WelcomeHeader> = ({ content }) => {
    const [profiles, setProfiles] = useState<Profiles>(null);

    const profileContext = useContext(ProfileContext);
    const profile = profileContext.profile;
    
    useEffect(() => {
		if (profile) {
			setProfiles(profile);
		}
	}, [profile]);

    return <WelcomeHeader {...content?.properties} profiles={profiles} />;
};
